// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__12U2K","isLoading":"styles_isLoading__14PrI","isHover":"styles_isHover__1NZyt"};